import { useAuth } from "@/context/AuthContext";
import { firestore } from "@/firebase/web";
import { doc, serverTimestamp, updateDoc } from "firebase/firestore";
import { useEffect } from "react";

// Stamps users/{uid}.groupsLastViewedAt.<groupId> on the current viewer when
// they open a group, so the "new posts" dot on the groups list clears.
// Fire-and-forget: a rules/offline failure must not block the screen.
export const useMarkGroupViewed = (groupId: string | undefined | null) => {
  const { user } = useAuth();
  const uid = user?.uid;
  useEffect(() => {
    if (!groupId || !uid) return;
    updateDoc(doc(firestore, "users", uid), {
      [`groupsLastViewedAt.${groupId}`]: serverTimestamp(),
    }).catch((err) => {
      console.warn("Failed to update groupsLastViewedAt on group entry", err);
    });
  }, [groupId, uid]);
};
